import styled from 'styled-components';

import { gridSizes, media, weights } from 'utils/style';
import BillingInfoForm from 'components/PaymentData/BillingInfoForm/container';

export default styled(BillingInfoForm)`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: visible;

  ${media.lessThan('medium')`
    overflow-y: auto;
  `};

  h1 {
    color: var(--grey900);
    font-size: 32px;
    margin: 0;
    font-weight: ${weights('medium')};
    line-height: 38px;
    margin-bottom: ${gridSizes('M')};
  }

  h2 {
    color: var(--grey900);
    font-size: ${gridSizes('M')};
    margin: 0;
    font-weight: ${weights('medium')};
    line-height: 19px;
  }

  p {
    color: var(--grey700);
    margin-top: 2px;
  }

  .field-row{
    display: flex;
    flex-direction: row;
    margin-bottom: ${gridSizes('M')};
    ${media.lessThan('small')`
      flex-direction: column;
      margin-bottom: 0px;
    `};




    .half{
      width: 50%;

      ${media.lessThan('small')`
        width: 100%;
      `};

    }

    .flex-2{
      flex: 2
      margin-right: ${gridSizes('M')};
      ${media.lessThan('small')`
        margin: ${gridSizes('S')} 0px;
      `};

    }
    .flex-3{
      flex: 3
      ${media.lessThan('small')`
        margin: ${gridSizes('S')} 0px;
      `};
    }
  }


  .billing-person{
    margin-top: ${gridSizes('M')};
    p{
      margin-top: ${gridSizes('S')};
    }
  }

`;
